import React, { useContext, useState, useEffect } from "react"
import Header from "../Global/Header"
import PageContent from "../Global/PageContent"
import Image from "../Global/Image"
import Footer from "../Global/Footer"
import Paciente from "./Paciente"
import SVGConfirmacao from "../../assets/confirmacao2.svg"

import { FiPhone } from "react-icons/fi"
import { BsWhatsapp } from "react-icons/bs"
import { GlobalContext } from "../../contexts/global"
import logoSegmedic from "../../assets/logo-segmedic.svg"
import "./style.css"
import NpsRating from "./NpsRating"

export default function Confirmacao() {
  const { statusSegmais } = useContext(GlobalContext)
  const [ isNpsOpen, setIsNpsOpen] = useState(false)

    useEffect(() => {
    const timer = setTimeout(() => {
      setIsNpsOpen(true)
    }, 1000)

    return () => clearTimeout(timer)
  }, [])


  const mainClassName = statusSegmais ? "page-segmais" : ""
    const handleAreaDoPaciente = () => {
    window.location.replace("https://app.segmedic.com.br/sign-in")
  }

  const handleAgendarNovamente = () => {
    window.location.replace("https://agendamento.segmedic.com.br/")
  }

  return (
    <main className={`site-main page-valor ${mainClassName}`}>
      <Header back_to="/" backToHome={true} hideFollowUP={true} />
      <PageContent>

        <div className="ConfirmationSection">
          <Image url={SVGConfirmacao} className="align-left" />
          <h1 className="align-left" style={{ marginTop: "1rem" }}>
            Agendamento realizado <br /> com sucesso !
          </h1>
          <h2 className="align-left" style={{ marginTop: "1rem", fontSize: "1rem" }}>
            Você receberá a confirmação via e-mail.
          </h2>

<div className="button-group" style={{ marginTop: "0.5rem", display: "flex", flexDirection: "column" }}>

  <button className="item-agendar-novamente" onClick={handleAgendarNovamente}>
    Agendar novamente
  </button>

  <button className="item-area-paciente" onClick={handleAreaDoPaciente}>
    Ver Agendamentos
  </button>

</div>
        </div>
      
        <Paciente />
        <Footer />
        <NpsRating isOpen={isNpsOpen} onClose={() => setIsNpsOpen(false)} />
      </PageContent>



    </main>
  )
}
